import { Injectable } from '@angular/core';
import { LedgerEntry, supplierEntry } from "./ledger-entry";

import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { promise } from 'protractor';
declare var M: any;
@Injectable({
  providedIn: 'root'
})
export class LedgerService {


  Ledger: AngularFirestoreCollection<LedgerEntry>;
  Shipments: AngularFirestoreCollection<supplierEntry>;
  Supplier: AngularFirestoreCollection<supplierEntry>;
  private LedgerDoc: AngularFirestoreDocument<LedgerEntry>;
  ledger: Observable<any[]>;

  constructor(private db: AngularFirestore) {
    //Get the tasks collection
    this.Ledger = db.collection<LedgerEntry>("generalLedger");
    this.Shipments = db.collection<supplierEntry>("generalShipments");
    this.Supplier = db.collection<supplierEntry>("generalSupplier");

  }
  getLedger() {
  //  console.log("ledger");
    this.db.collection<LedgerEntry>("generalLedger").get().pipe(map((querySnapshot) => {
    //  console.log(querySnapshot);
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
      //  console.log(doc.id, " => ", doc.data());
      });
    }));
  }
  addTask(LedgerEntry: LedgerEntry) {
    //Add the new task to the collection
    let docRef;
      let ret = this.Ledger.add(LedgerEntry).then((ledger) => {
        docRef = ledger;
        M.toast({ html: 'Ledger entry added!' });
        return ledger;
      })
        ret.catch((error) => {
        M.toast({ html: error })
      });
    return ret;
    // return new promise((resolve) => {
    //   resolve();
    //  });
  }
  //addTask
  updateTask(id, update) {
    //Get the task document
    this.LedgerDoc = this.db.doc<LedgerEntry>(`${"generalLedger"}/${id}`);
    this.LedgerDoc.update(update).then((ledger) => {
      M.toast({ html: 'Ledger entry updated!' })
    }).catch((error) => {
      M.toast({ html: error })
    });
  } //updateTask
  deleteTask(id) {
    //Get the task document
    this.LedgerDoc = this.db.doc<LedgerEntry>(`${"generalLedger"}/${id}`);
    //Delete the document
    this.LedgerDoc.delete().then(ledger => { 
      M.toast({ html: 'ledger entry deleted!' })
    }).catch((error) => {
      M.toast({ html: error })
    });
  } //deleteTask
  addShipment(LedgerEntry: LedgerEntry, rate: any) {
    this.Shipments.doc(LedgerEntry.supplier.replace(/\s/g, '') + LedgerEntry.shipmentNumber).set({
      id: LedgerEntry.supplier.replace(/\s/g, '') + LedgerEntry.shipmentNumber,
      supplier: LedgerEntry.supplier,
      shipmentNumber: LedgerEntry.shipmentNumber,
      rate: rate
    });
  }
  addSupplier(LedgerEntry: LedgerEntry, leadTime: any) {
    this.Supplier.doc(LedgerEntry.supplier.replace(/\s/g, '')).set({
      id: LedgerEntry.supplier.replace(/\s/g, ''),
      supplier: LedgerEntry.supplier,
      leadTime: leadTime
    });
  }
  updateSupplierShipment(LedgerEntry: LedgerEntry, leadTime: any, rate:any) {
    this.Shipments.doc(LedgerEntry.supplier.replace(/\s/g, '') + LedgerEntry.shipmentNumber).set({
      id: LedgerEntry.supplier.replace(/\s/g, '') + LedgerEntry.shipmentNumber,
      supplier: LedgerEntry.supplier,
      shipmentNumber: LedgerEntry.shipmentNumber,
      rate: rate
    });
    this.Supplier.doc(LedgerEntry.supplier.replace(/\s/g, '')).set({
      id: LedgerEntry.supplier.replace(/\s/g, ''),
      supplier: LedgerEntry.supplier,
      leadTime: leadTime
    }).then(any => {
      M.toast({ html: 'Supplier data updated!' })
    }).catch((error) => {
      M.toast({ html: error })
    });
  }
  // updateSupplierShipment(id, rate) {
  //   //Get the task document
  //   this.LedgerDoc = this.db.doc<LedgerEntry>(`${"generalShipments"}/${id}`);
  //   this.LedgerDoc.update(update);
  //   M.toast({ html: 'Done!' })
  // }
  // updateSupplier(id, update) {
  //   //Get the task document
  //   this.LedgerDoc = this.db.doc<LedgerEntry>(`${"generalSupplier"}/${id}`);
  //   this.LedgerDoc.update(update);
  //   M.toast({ html: 'Done!' })
  // }
}
